export default "__VITE_ASSET__DYoHjicP__"